<div class="color-palette">
  <h1>{{ 'updatePortalFeatures.colorPalette.title' | translate }}</h1>
  <p>{{ 'updatePortalFeatures.colorPalette.description' | translate }}</p>
  <div class="color-palette-content">
    <div class="carousel-nav-left" (click)="previous()" [ngClass]="{ 'disabled': currentIndex === 0 }">
      <div class="arrow-left"></div>
    </div>
    <div class="carousel-container">
      @for (palette of visiblePalettes; track palette; let i = $index) {
        <div class="palette" [class.active]="palette === selectedPalette" (click)="selectPalette(palette)">
          <img [src]="palette.image" [alt]="palette.title">
          <h1>{{ palette.title }}</h1>
          <div class="preview">
            <div class="preview-text">
              <!-- <img src="../../../assets/icons/ver.png" alt="preview">
              <p class="text-right">Vista previa</p> -->
            </div>
            <div  class="round-checkbox">
              <input type="checkbox" [name]="'paletteCheckbox'" id="{{ 'checkbox-' + i }}" [checked]="palette === selectedPalette" >
            </div>
          </div>
        </div>
      }
    </div>
    <div class="carousel-nav-right" [ngClass]="{ 'disabled': currentIndex === palettes.length - 1 }"
      (click)="next()">
      <div class="arrow-right"></div>
    </div>
  </div>
</div>